<template>
<div style="min-height: 100vh; position: relative">
    <navComponent/>
  <div class="container-fluid">
    <div
						class="modal" id="report-issue" tabindex="-1"
						role="dialog" aria-labelledby="report-issue"
						aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Report issue</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-report-isse">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Name</label>
							<input
											type="email" id="ri-name" class="form-control" v-model="name" aria-describedby="emailHelp"
											required>
						</div>
						<div class="form-group">
							<label>Email address</label>
							<input
											type="email" class="form-control" v-model="email" id="ri-email" required
											aria-describedby="emailHelp">
						</div>
						<div class="form-group">
							<label>Phone Number</label>
							<input
											type="text" class="form-control" v-model="number" required id="ri-number"
											aria-describedby="emailHelp">
						</div>
						<div class="form-group">
              <label>Please describe the issue</label>
							<textarea class="form-control" style="background: #000;" v-model="purpose" required id="ri-issue" aria-describedby="emailHelp">
							</textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary text-dark" id="report-issue-submit" @click="reportIssue">
							<b>Submit</b>
						</button>
					</div>
				</div>
			</div>
		</div>
    <div class="container">
	    <div class="row">
		    <div class="col-md-9">
			    <div class="container">
				    <h1>Solution to some common issues faced by users</h1>
			    </div>
			    <div id="accordion">
				    <div class="card">
					    <div class="card-header">
						    <a class="card-link" data-toggle="collapse" href="#collapseOne">
							    <i class="fa fa-star"></i> Stuck on initializing video call on table chair page, error says Permission Denied ...
						    </a>
					    </div>
					    <div
						    id="collapseOne"
						    class="collapse show"
						    data-parent="#accordion"
					    >
						    <div class="card-body">
							    This case usually happens when you block the permission for Audio and Camera, you have to make sure the Permissions for camera and audio have been granted.
							    You can see this icon <img src="../assets/blocked-icon.png" alt="Blocked Permission" class="img-responsive"/> if permission have not been granted.
							    <br />
							    <br />
							    Follow the below steps to fix this issue:
							    <br />
							    <ol>
								    <li style="margin-top: 40px">
									    If you see this icon <img src="../assets/blocked-icon.png" alt="Blocked Permission"/>, click on it.
								    </li>
								    <li style="margin-top: 20px">
									    You can see currently the services access are denied. Click on "Always Allow ..".
									    <br />
									    <br />
									    <img src="../assets/camera-micophone-blocked.png" alt="Camera Microphone Popup" class="img-fluid"/>
								    </li>
								    <li style="margin-top: 20px">
									    Click on done
									    <br />
									    <br />
									    <img class="img-fluid" src="../assets/allow-permissions.png" alt="Allow permission"  width="650" height="450" />
								    </li>
								    <li style="margin-top: 40px">
									    Press F5 / Ctrl+R (windows) to reload  or simply press the yellow circled icon in the image.
									    <br />
									    <br />
									    <img class="img-fluid" src="../assets/reload.png" alt="Reload Page" width="900" />
								    </li>
							    </ol>
						    </div>
					    </div>
				    </div>
				    <!-- <div class="card">
							<div class="card-header">
								<a
									class="collapsed card-link"
									data-toggle="collapse"
									href="#collapseTwo"
								>
									Collapsible Group Item #2
								</a>
							</div>
							<div id="collapseTwo" class="collapse" data-parent="#accordion">
								<div class="card-body">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
									eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
									enim ad minim veniam, quis nostrud exercitation ullamco laboris
									nisi ut aliquip ex ea commodo consequat.
								</div>
							</div>
						</div> -->
				    <!-- <div class="card">
							<div class="card-header">
								<a
									class="collapsed card-link"
									data-toggle="collapse"
									href="#collapseThree"
								>
									Collapsible Group Item #3
								</a>
							</div>
							<div id="collapseThree" class="collapse" data-parent="#accordion">
								<div class="card-body">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
									eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
									enim ad minim veniam, quis nostrud exercitation ullamco laboris
									nisi ut aliquip ex ea commodo consequat.
								</div>
							</div>
						</div> -->
			    </div>
		    </div>
		    <div class="col-md-3">
			    <div class="card" style="background: #1B1B1B;">
				    <div class="text-center card-body">
					    <p>Unable to find your query ?</p>
					    <button type="button" class="btn-primary btn btn-block" data-toggle="modal" data-target="#report-issue">Report a new issue</button>
				    </div>
			    </div>
		    </div>
	    </div>
    </div>
  </div>
  <div style="position: absolute; bottom: 0; width: 100%;height: 100px">
  <footerComp/>
  </div>
</div>
</template>
<script>
import navComponent from "@/components/nav.vue";
import footerComp from "@/components/footer.vue";

export default {
  name: "fix-issues",
  data(){
    return {
      name: "",
        email: "",
        number: "",
        purpose: ""
    }
  },
  components: {
    navComponent,
    footerComp
  },
  methods: {
    reportIssue: function () {
        if (this.name === "") {
          this.$toast.open({
            message: "Please enter name",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.email === "") {
          this.$toast.open({
            message: "Please enter email",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.purpose === "") {
          this.$toast.open({
            message: "Please enter purpose",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.number === "") {
          this.$toast.open({
            message: "Please enter phone number",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          let data = {
            'name': this.name,
            'email': this.email,
            'number': this.number,
            'purpose': this.purpose
          }
          this.$store.dispatch('reportIssue', data).then(resp => {
            if (resp.data.status === "success") {
              this.name = ""
              this.email = ""
              this.number = ""
              this.purpose = ""
              document.getElementById('close-report-issue').click()
              this.$toast.open({
                message: "Thanks for reaching out, our team will resolve your query asap.",
                type: 'success',
				position: 'top',
				queue: true
              });
            }
          })
        }
      }
  },
  created() {
      if (localStorage.getItem('user_info')) {
        this.name = JSON.parse(localStorage.getItem('user_info')).name
        this.email = JSON.parse(localStorage.getItem('user_info')).email
      }
    },
};
</script>
<style lang="scss" scoped>
  .card {
    margin-top: 5px;
    margin-bottom: 120px;
  }
  #report {
    border: 10px solid rgb(27, 27, 27);
    position: sticky;
    top: 15px;
    margin-bottom: 120px
  }
  #report h5 {
    padding: 15px;
  }
  #report button {
    margin: 0 auto;
    margin-bottom: 10px;
  }
</style>
